import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import {
  fioLitleTruncateFromObject,
  sumFormat,
  suffixMoney
} from "../../lib/helpers/strings";
import {
  getDateFormat,
  getDateReturnDaysString
} from "../../lib/helpers/dates";
import { getDayLabelNumber } from "../../lib/helpers/wordForm";
import {
  getStatusString,
  getStatusClassString
} from "../../lib/helpers/bilets";
import { sortOnCreatedAt } from "../../lib/helpers/sort";

// UI
import {
  Alerts,
  Box,
  Header,
  HeaderPage,
  P,
  Button,
  HR,
  Row,
  Col,
  Modal
} from "../../ui";

// COMPONENTS
import TableHistorys from "./components/historys";
import TableBlanks from "./components/blanks";
import TableItems from "./components/items";

class BiletOnePage extends Component {
  state = {
    loadingItems: true,
    titleHeader: "Залоговый билет",
    bilet: { user_id: {}, depositor_id: {}, filial_id: {}, items_id: [] },
    historysOriginal: [],
    modals: {
      deleteBilet: {
        title: "Удаление залогового билета",
        yesTitle: "Удалить билет",
        yesClassName: "error",
        isShow: false,
        yesDisabled: false
      }
    }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;
    const bilet = await API.bilets.getOne(id);

    if (bilet && Object.keys(bilet) && bilet.fine && bilet.fine.length) {
      bilet.fine.sort(sortOnCreatedAt);
    }

    let titleHeader = `${bilet.bilet_number} - ${this.state.titleHeader}`;

    this.setState({ bilet, titleHeader });

    const historysOriginal = await API.bilets.getBiletHistorys(id);

    this.setState({ historysOriginal });
  }

  /**
   * Открытие мобального окна
   */
  handleModalShow = (modalName = "", isShow) => {
    this.setState(prevState => {
      return {
        modals: {
          ...prevState.modals,
          [modalName]: {
            ...prevState.modals[modalName],
            isShow
          }
        }
      };
    });
  };

  /**
   * Удаление билета
   */
  handleDeleteBilet = async e => {
    e.preventDefault();

    const { id: biletId } = this.props.match.params;

    this.setState({
      loading: true
    });

    const deletedBilet = await API.bilets.deleteOne(biletId, {
      full: true
    });

    if (deletedBilet) {
      Alerts.success("Залоговый билет успешно удалён");

      this.props.history.goBack();
    } else {
      Alerts.error("Залоговый билет не удалён");
    }

    this.handleModalShow("deleteBilet", false);
  };

  render() {
    const { id } = this.props.match.params;
    const { bilet, historysOriginal } = this.state;

    if (bilet && bilet.bilet_number) {
      return (
        <div className="short">
          <Helmet>
            <title>{this.state.titleHeader}</title>
          </Helmet>

          <HeaderPage
            title={this.state.titleHeader + " №" + bilet.bilet_number}
            back={this.props.history.goBack}
          >
            <Button
              type="button"
              theme="error"
              size="s"
              onClick={() => this.handleModalShow("deleteBilet", true)}
            >
              Удалить
            </Button>
          </HeaderPage>

          <Box>
            <Row withMain={true}>
              <Col padding="no" main={true}>
                <Header size={2} margin="no-top">
                  Текущее состояние
                </Header>
              </Col>
              <Col padding="no" normal={true}>
                <Button size="s" type="as" as={Link} to={`/bilets/${id}/edit`}>
                  Изменить состояние
                </Button>
              </Col>
            </Row>

            <Row>
              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Header size={6} margin="no-bottom">
                  Номер з/б:
                </Header>
                <P slim>{bilet.bilet_number}</P>

                <Header size={6} margin="no-bottom">
                  Последняя операция:
                </Header>
                <P slim>
                  <span
                    className={`label label-${getStatusClassString(
                      bilet.status,
                      true
                    )}`}
                  >
                    {getStatusString(bilet.status, true, true)}
                  </span>
                </P>

                <Header size={6} margin="no-bottom">
                  Филиал:
                </Header>
                <P slim>
                  <Link to={`/filials/${bilet.filial_id._id}`}>
                    {bilet.filial_id.name}
                  </Link>
                </P>
              </Col>

              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Сроки
                </Header>

                <Header size={6} margin="no-bottom">
                  Первая операция:
                </Header>
                <P slim>{getDateFormat(bilet.date_created)}</P>

                <Header size={6} margin="no-bottom">
                  Дата возврата:
                </Header>
                <P slim>{getDateFormat(bilet.date_return)}</P>

                <Header size={6} margin="no-bottom">
                  Всего дней:
                </Header>
                <P slim>{getDayLabelNumber(bilet.days)}</P>

                <Header size={6} margin="no-bottom">
                  Когда возврат:
                </Header>
                <P slim>{getDateReturnDaysString(bilet.date_return, true)}</P>

                {bilet.status === "continue" ? (
                  <div>
                    <Header size={6} margin="no-bottom">
                      Продлён на:
                    </Header>
                    <P slim={true}>{getDayLabelNumber(bilet.days_new)}</P>
                  </div>
                ) : null}
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Деньги
                </Header>

                <Header size={6} margin="no-bottom">
                  Сумма оценки:
                </Header>
                <P slim={true}>{sumFormat(bilet.sum_items, suffixMoney)}</P>

                <Header size={6} margin="no-bottom">
                  Сумма выдачи:
                </Header>
                <P slim={true}>{sumFormat(bilet.sum_give, suffixMoney)}</P>

                <Header size={6} margin="no-bottom">
                  Используемый процент:
                </Header>
                <P slim={true}>{sumFormat(bilet.percent, suffixMoney)}</P>

                <Header size={6} margin="no-bottom">
                  Сумма процентов:
                </Header>
                <P slim={true}>{sumFormat(bilet.sum_percent, suffixMoney)}</P>

                <Header size={6} margin="no-bottom">
                  Сумма возврата:
                </Header>
                <P slim={true}>{sumFormat(bilet.sum_return, suffixMoney)}</P>
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Люди
                </Header>

                <Header size={6} margin="no-bottom">
                  Залогодатель:
                </Header>
                <P slim={true}>
                  <Link to={`/depositors/${bilet.depositor_id._id}`}>
                    {fioLitleTruncateFromObject(bilet.depositor_id)}
                  </Link>
                </P>

                <Header size={6} margin="no-bottom">
                  Ответсвенный за приём:
                </Header>
                <P slim={true}>
                  <Link to={`/users/${bilet.user_id._id}`}>
                    {fioLitleTruncateFromObject(bilet.user_id)}
                  </Link>
                </P>
              </Col>

              <Col padding="no-top-right">
                <Header size={5} margin="no-top">
                  Изменения
                </Header>

                <Header size={6} margin="no-bottom">
                  Дата создания з/б:
                </Header>
                <P slim={true}>{getDateFormat(bilet.created_at)}</P>

                <Header size={6} margin="no-bottom">
                  Дата обновления з/б:
                </Header>
                <P slim={true}>{getDateFormat(bilet.updated_at)}</P>
              </Col>
            </Row>

            <br />

            <Row>
              <Col padding="no-top-left">
                <Header size={6} margin="no">
                  Комментарий:
                </Header>
                <P size="small" margin="no-top">
                  {bilet.comment || "Комментарий не задан"}
                </P>
              </Col>

              <Col padding="no-top">
                <Header size={6} margin="no">
                  HASH-текущий:
                </Header>
                <P size="small" margin="no-top">
                  {bilet.hash}
                </P>
              </Col>

              <Col padding="no-top-right">
                <Header size={6} margin="no">
                  HASH-предыдущий:
                </Header>
                <P size="small" margin="no-top">
                  {bilet.hash_old}
                </P>
              </Col>
            </Row>

            <HR mutted theme={"dashed"} />

            <TableHistorys biletId={id} historysOriginal={historysOriginal} />

            <HR mutted theme={"dashed"} />

            <TableBlanks biletId={id} historysOriginal={historysOriginal} />

            <HR mutted theme={"dashed"} />

            <TableItems biletId={id} />
          </Box>

          <Modal
            title={this.state.modals.deleteBilet.title}
            show={this.state.modals.deleteBilet.isShow}
            yesTitle={this.state.modals.deleteBilet.yesTitle}
            yesHandlerOnClick={this.handleDeleteBilet}
            yesThemeButton={this.state.modals.deleteBilet.yesClassName}
            yesDisabled={this.state.modals.deleteBilet.yesDisabled}
            noHandlerOnClick={() => this.handleModalShow("deleteBilet", false)}
          >
            <P>
              Вы действительно хотите удалить залоговый билет №
              {this.state.bilet.bilet_number}?
              <br />
              <br />
              Эта операция также выполнит:
              <ul>
                <li>
                  Удаление историй залогового билета №
                  {this.state.bilet.bilet_number}.
                </li>
                <li>
                  Удаление кассовых ордеров для залогового билета №
                  {this.state.bilet.bilet_number}.
                </li>
                <li>
                  Удаление вещей из залогового билета №
                  {this.state.bilet.bilet_number}.
                </li>
                <li>
                  Восстановление выданных денег ({sumFormat(bilet.sum_give)})
                  <br />в кассу на конец дня для филиала: {bilet.filial_id.name}
                  .
                </li>
              </ul>
            </P>
          </Modal>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(withAuth(BiletOnePage));
